// ========================================
// src/utils/permissions.js
// ========================================
export const PERMISSIONS = {
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_STATS: 'view_stats',
  VIEW_CHARTS: 'view_charts',
  
  VIEW_METERS: 'view_meters',
  ADD_METER: 'add_meter',
  EDIT_METER: 'edit_meter',
  DELETE_METER: 'delete_meter',
  BLOCK_METER: 'block_meter',
  CONFIGURE_METER: 'configure_meter',
  
  VIEW_CUSTOMERS: 'view_customers',
  ADD_CUSTOMER: 'add_customer',
  EDIT_CUSTOMER: 'edit_customer',
  DELETE_CUSTOMER: 'delete_customer',
  BLOCK_CUSTOMER: 'block_customer',
  
  VIEW_TRANSACTIONS: 'view_transactions',
  CREATE_SALE: 'create_sale',
  CANCEL_TRANSACTION: 'cancel_transaction',
  REFUND_TRANSACTION: 'refund_transaction',
  
  VIEW_FEES: 'view_fees',
  RECORD_PAYMENT: 'record_payment',
  GENERATE_FEES: 'generate_fees',       // ✅ NOUVEAU : générer mois manquants (admin only par défaut)
  
  VIEW_ALERTS: 'view_alerts',
  MARK_ALERT_READ: 'mark_alert_read',
  RESOLVE_ALERT: 'resolve_alert',
  
  VIEW_USERS: 'view_users',
  ADD_USER: 'add_user',
  EDIT_USER: 'edit_user',
  DELETE_USER: 'delete_user',
  BLOCK_USER: 'block_user', // nouvelle permission pour bloquer/activer
  
  
  VIEW_REPORTS: 'view_reports',
  EXPORT_REPORTS: 'export_reports',
  
  CONFIGURE_SYSTEM: 'configure_system',
  CONFIGURE_WAVE: 'configure_wave',
  CONFIGURE_SMS: 'configure_sms',
  
  VIEW_MONITORING: 'view_monitoring',
  UPDATE_RISK_SCORES: 'update_risk_scores',
  BLOCK_INACTIVE: 'block_inactive',

  VIEW_ACCOUNTING: 'view_accounting',
  MANAGE_EXPENSES: 'manage_expenses',

   // ✅ NOUVEAU : Contrôle à Distance
  VIEW_REMOTE_CONTROL: 'view_remote_control',       // voir la page + actions de lecture (relevé, infos, historique)
  EXECUTE_REMOTE_ACTIONS: 'execute_remote_actions',  // actions sensibles (bloquer, débloquer, recharge, bascule, DCU)
  // ✅ NOUVEAU : Contrats
  VIEW_CONTRACTS: 'view_contracts',       // voir la page + l'historique
  ADD_CONTRACT: 'add_contract',           // générer un nouveau contrat
  EDIT_CONTRACT: 'edit_contract',         // modifier un contrat existant
  DELETE_CONTRACT: 'delete_contract',     // supprimer un contrat

    // ✅ NOUVEAU : Centrales Solaires
  VIEW_POWER_PLANTS: 'view_power_plants',       // voir la page + le tableau des adresses
  MANAGE_POWER_PLANTS: 'manage_power_plants',   // ajouter/modifier/supprimer une centrale
  
};

export const ROLE_PERMISSIONS = {
  administrateur: [
    PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_STATS, PERMISSIONS.VIEW_CHARTS,
    PERMISSIONS.VIEW_METERS, PERMISSIONS.ADD_METER, PERMISSIONS.EDIT_METER,
    PERMISSIONS.DELETE_METER, PERMISSIONS.BLOCK_METER, PERMISSIONS.CONFIGURE_METER,
    PERMISSIONS.VIEW_CUSTOMERS, PERMISSIONS.ADD_CUSTOMER, PERMISSIONS.EDIT_CUSTOMER,
    PERMISSIONS.DELETE_CUSTOMER, PERMISSIONS.BLOCK_CUSTOMER,
    PERMISSIONS.VIEW_TRANSACTIONS, PERMISSIONS.CREATE_SALE, PERMISSIONS.CANCEL_TRANSACTION,
    PERMISSIONS.REFUND_TRANSACTION,
    PERMISSIONS.VIEW_FEES, PERMISSIONS.RECORD_PAYMENT,PERMISSIONS.GENERATE_FEES,
    PERMISSIONS.VIEW_ALERTS, PERMISSIONS.MARK_ALERT_READ, PERMISSIONS.RESOLVE_ALERT,
    PERMISSIONS.VIEW_USERS, PERMISSIONS.ADD_USER, PERMISSIONS.EDIT_USER, PERMISSIONS.DELETE_USER, PERMISSIONS.BLOCK_USER,
    PERMISSIONS.VIEW_REPORTS, PERMISSIONS.EXPORT_REPORTS,
    PERMISSIONS.CONFIGURE_SYSTEM, PERMISSIONS.CONFIGURE_WAVE, PERMISSIONS.CONFIGURE_SMS,
    PERMISSIONS.VIEW_MONITORING, PERMISSIONS.UPDATE_RISK_SCORES, PERMISSIONS.BLOCK_INACTIVE,
    PERMISSIONS.VIEW_ACCOUNTING, PERMISSIONS.MANAGE_EXPENSES,
    PERMISSIONS.VIEW_REMOTE_CONTROL, PERMISSIONS.EXECUTE_REMOTE_ACTIONS,
    PERMISSIONS.VIEW_CONTRACTS, PERMISSIONS.ADD_CONTRACT, PERMISSIONS.EDIT_CONTRACT, PERMISSIONS.DELETE_CONTRACT,
    PERMISSIONS.VIEW_POWER_PLANTS, PERMISSIONS.MANAGE_POWER_PLANTS,
  ],


  
  gestionnaire: [
    PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_STATS, PERMISSIONS.VIEW_CHARTS,
    PERMISSIONS.VIEW_METERS, PERMISSIONS.ADD_METER, PERMISSIONS.EDIT_METER,
    PERMISSIONS.BLOCK_METER,
    PERMISSIONS.VIEW_CUSTOMERS, PERMISSIONS.ADD_CUSTOMER, PERMISSIONS.EDIT_CUSTOMER,
    PERMISSIONS.BLOCK_CUSTOMER,
    PERMISSIONS.VIEW_TRANSACTIONS, PERMISSIONS.CREATE_SALE, PERMISSIONS.CANCEL_TRANSACTION,
    PERMISSIONS.REFUND_TRANSACTION,
    PERMISSIONS.VIEW_FEES, PERMISSIONS.RECORD_PAYMENT,
    PERMISSIONS.VIEW_ALERTS, PERMISSIONS.MARK_ALERT_READ, PERMISSIONS.RESOLVE_ALERT,
    PERMISSIONS.VIEW_REPORTS, PERMISSIONS.EXPORT_REPORTS,
    PERMISSIONS.VIEW_MONITORING, PERMISSIONS.UPDATE_RISK_SCORES,
    PERMISSIONS.VIEW_ACCOUNTING, PERMISSIONS.MANAGE_EXPENSES,
    PERMISSIONS.VIEW_REMOTE_CONTROL, PERMISSIONS.EXECUTE_REMOTE_ACTIONS,
    PERMISSIONS.VIEW_CONTRACTS, PERMISSIONS.ADD_CONTRACT, PERMISSIONS.EDIT_CONTRACT, PERMISSIONS.DELETE_CONTRACT,
    PERMISSIONS.VIEW_POWER_PLANTS, PERMISSIONS.MANAGE_POWER_PLANTS,
  ],
  
  operateur: [
    PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_STATS, PERMISSIONS.VIEW_CHARTS,
    PERMISSIONS.VIEW_METERS,
    PERMISSIONS.VIEW_CUSTOMERS,
    PERMISSIONS.VIEW_TRANSACTIONS, PERMISSIONS.CREATE_SALE,
    PERMISSIONS.VIEW_FEES,
    PERMISSIONS.VIEW_ALERTS, PERMISSIONS.MARK_ALERT_READ,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.VIEW_ACCOUNTING,
    PERMISSIONS.VIEW_REMOTE_CONTROL, PERMISSIONS.EXECUTE_REMOTE_ACTIONS,
    PERMISSIONS.VIEW_CONTRACTS, PERMISSIONS.ADD_CONTRACT, PERMISSIONS.EDIT_CONTRACT, PERMISSIONS.DELETE_CONTRACT,
    PERMISSIONS.VIEW_POWER_PLANTS, PERMISSIONS.MANAGE_POWER_PLANTS,
  ],
  
  lecture: [
    PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_STATS, PERMISSIONS.VIEW_CHARTS,
    PERMISSIONS.VIEW_METERS,
    PERMISSIONS.VIEW_CUSTOMERS,
    PERMISSIONS.VIEW_TRANSACTIONS,
    PERMISSIONS.VIEW_FEES,
    PERMISSIONS.VIEW_ALERTS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.VIEW_REMOTE_CONTROL,
    PERMISSIONS.VIEW_CONTRACTS,
    PERMISSIONS.VIEW_POWER_PLANTS,
  ]
};

// src/utils/permissions.js

// Permission unique
export const hasPermission = (user, permission) => {
  if (!user) return false;

  // 🔥 ADMIN = TOUT ACCÈS
  if (user.role === 'administrateur') return true;

  if (!user.permissions || !Array.isArray(user.permissions)) return false;

  return user.permissions.includes(permission);
};

// Plusieurs permissions (au moins une)
export const hasAnyPermission = (user, permissions = []) => {
  if (!user) return false;

  if (user.role === 'administrateur') return true;

  if (!user.permissions) return false;

  return permissions.some(p => user.permissions.includes(p));
};

// Accès page
export const canAccessPage = (user, requiredPermissions = []) => {
  if (!user) return false;

  // 🔥 ADMIN PASSE TOUJOURS
  if (user.role === 'administrateur') return true;

  if (requiredPermissions.length === 0) return true;

  if (!user.permissions) return false;

  return requiredPermissions.every(p => user.permissions.includes(p));
};



export const hasAllPermissions = (user, permissions) => {
  if (!user || !user.permissions) return false;
  return permissions.every(p => user.permissions[p] === true);
};

export const getUserPermissions = (user) => {
  if (!user || !user.role) return [];
  return ROLE_PERMISSIONS[user.role] || [];
};


